export function getInviteByID(invites, id) {
    return invites.find((invite) => invite.id === id) || {};
}
